import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import {
  IonHeader,
  IonTitle,
  IonToolbar,
  IonLabel,
  IonPage,
  IonContent,
  IonBackButton,
  IonButtons,
  isPlatform,
  IonSegment,
  IonSegmentButton,
} from "@ionic/react";

// Actions
import findOnePaymentNotice from "../../store/paymentNoticeDetail/actions/findOnePaymentNotice";
import findPaymentNoticeMessages from "../../store/paymentNoticeDetail/actions/findPaymentNoticeMessages";
import findPaymentReconciliations from "../../store/paymentNoticeDetail/actions/findPaymentReconciliations";
// Selectors
import { selectViewSegmentSelected } from "../../store/paymentNoticeDetail/selectors/selectViewSegmentSelected";
// Components
import { SegmentInfo } from "./components/SegmentInfo";
import { SegmentMessages } from "./components/SegmentMessages";

export const PaymentNoticeDetail: React.FC = () => {
  const dispatch = useDispatch();

  const viewSegmentSelected = useSelector(selectViewSegmentSelected);

  // Buscar detalles al cambiar parámetro id de la url
  const { id }: { id: string } = useParams();

  useEffect(() => {
    const findData = (id: any) => {
      dispatch(findOnePaymentNotice(parseInt(id)));
      dispatch(findPaymentReconciliations(parseInt(id)));
      dispatch(findPaymentNoticeMessages(parseInt(id)));
    };

    findData(id);
  }, [id, dispatch]);

  // Data
  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton
              text={isPlatform("ios") ? "Cuentas" : ""}
              defaultHref="/contabilidad"
              color="light"
            />
          </IonButtons>
          <IonTitle>Abono</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense" class="ion-no-border">
          <IonToolbar>
            <IonTitle size="large">Abono</IonTitle>
          </IonToolbar>
        </IonHeader>

        <section
          className="ion-padding-horizontal ion-padding-top"
          style={{
            maxWidth: "800px",
          }}
        >
          <IonSegment
            onIonChange={(e) => {
              dispatch({
                type: "paymentNoticeDetail/setViewSegmentSelected",
                payload: e.detail.value,
              });
            }}
            value={viewSegmentSelected}
            color="primary"
          >
            <IonSegmentButton value="info">
              <IonLabel>Información</IonLabel>
            </IonSegmentButton>
            <IonSegmentButton value="messages">
              <IonLabel>Actividad</IonLabel>
            </IonSegmentButton>
          </IonSegment>
        </section>

        <section
          style={{
            maxWidth: "800px",
          }}
          className={isPlatform("desktop") ? "ion-padding" : ""}
        >
          {viewSegmentSelected === "info" && <SegmentInfo />}
          {viewSegmentSelected === "messages" && <SegmentMessages />}
        </section>
      </IonContent>
    </IonPage>
  );
};
